import React, { useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import case1 from "../assets/images/case/case_01.jpg";
import case2 from "../assets/images/case/case_02.jpg";
import case3 from "../assets/images/case/case_03.jpg";
import case4 from "../assets/images/case/case_04.jpg";
import case5 from "../assets/images/case/case_05.jpg";
import case6 from "../assets/images/case/case_06.jpg";

function Cases() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const cases = [
    { id: 1, image: case1, title: "원형풀 시공", description: "대규모 워터파크 원형풀 시공 사례" },
    { id: 2, image: case2, title: "유수풀 시스템", description: "순환 기술이 적용된 유수풀 설계" },
    { id: 3, image: case3, title: "추암 관광랜드", description: "관광지 내 대형 수영장 조성" },
    { id: 4, image: case4, title: "고령 부채골공원", description: "지역 랜드마크 공원 수시설" },
    { id: 5, image: case5, title: "안산 눈썰매장", description: "계절별 테마파크 수영장 변환" },
    { id: 6, image: case6, title: "가평 모데르노", description: "고급 펜션 프라이빗 풀 시공" },
  ];

  const images = cases.map((item) => ({
    original: item.image,
    thumbnail: item.image,
    description: item.title,
  }));

  const handleClose = () => setIsOpen(false);

  return (
    <section id="cases" className="section-padding bg-slate-50">
      <div className="container mx-auto px-6">
        <header className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-[0.3em] mb-4">Construction Cases</h2>
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">시공 사례</h1>
          <p className="text-lg text-slate-600 font-light">전국 곳곳에서 증명된 워터피아만의 독보적인 시공 능력을 확인해 보세요.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {cases.map((item, index) => (
            <div
              key={item.id}
              className="group relative bg-white rounded-3xl overflow-hidden premium-shadow transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              onClick={() => {
                setCurrentIndex(index);
                setIsOpen(true);
              }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors">{item.title}</h3>
                <p className="text-slate-500 font-light leading-relaxed">{item.description}</p>
              </div>
              <div className="absolute top-6 right-6 w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity border border-white/20">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {isOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/95 backdrop-blur-sm" onClick={handleClose} />
            <button className="absolute top-8 right-8 z-[110] text-white/50 hover:text-white transition-colors" onClick={handleClose}>
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="relative z-[105] w-full max-w-6xl">
              <ImageGallery
                items={images}
                startIndex={currentIndex}
                showPlayButton={false}
                showFullscreenButton={false}
                showThumbnails={false}
                onSlide={setCurrentIndex}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Cases;
